var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-loading picture-skeleton",style:({ width: _vm.itemWidth, paddingTop: _vm.itemHeight }),attrs:{"data-cy":"skeleton-loader"}})
}
var staticRenderFns = []

export { render, staticRenderFns }